export class VerifyPathError extends Error {
    constructor(
        message: string,
        public status: number,
        public needRedirect = false,
        public newUrl?: string,
        public queries: { [key: string]: string | undefined } = {},
        public replace = false
    ) {
        super(message);
    }
}

export class ViewNotFoundError extends VerifyPathError {
    constructor(message: string, status = 404) {
        super(message, status, false);
    }
}

export class ViewRedirectError extends VerifyPathError {
    constructor(
        message: string,
        newUrl: string,
        queries: { [key: string]: string | undefined } = {},
        status = 301,
        replace = false
    ) {
        super(message, status, true, newUrl, queries, replace);
    }

    declare needRedirect: true;

    declare newUrl: string;
}

export enum ReserveType {
    Flight = 'flight',
    Train = 'train',
    Bus = 'bus',
    Taxi = 'taxi',
    Hotel = 'hotel',
    Route = 'route',
}

export interface ItineraryPathData {
    adultCount?: string;
    childCount?: string;
    infantCount?: string;
    [x: string]: string | undefined;
}
export interface ItineraryParams {}

export class RequestCanceledException extends Error {
    requestWasCanceled = true;
    requestAlreadyLoaded = false;
}

/**
 * Type of calendar
 */
export enum CalendarType {
    Jalali = 'jalali',
    Gregorian = 'gregory',
}

export enum AutoReserveType {
    None = 'none',
    Item = 'item',
    Route = 'route',
}
